export default __webpack_public_path__ + "static/media/element_spec_42.b82881fa.jpg";